module.exports = __webpack_public_path__ + "static/caixa_grey-655043d927c26f0b23f52c8da85fb15f.svg";